// src/lib/citationParser.ts
export interface ParsedCitation {
  raw: string;
  url: string;
}

export interface ParseResult {
  cleanedText: string;
  sources: ParsedCitation[];
}

function makeCitationUrl(raw: string): string {
  if (/u\.s\.c/i.test(raw)) {
    const section = raw.match(/§\s*([\d.-]+)/)?.[1] ?? '';
    return `https://www.law.cornell.edu/uscode/text/${section}`;
  }
  return `https://law.justia.com/search?q=${encodeURIComponent(raw)}`;
}

export function parseCitations(text: string): ParseResult {
  // Extract the **Sources:** section if present
  const sourcesMatch = text.match(/\*\*Sources:\*\*\s*([\s\S]*?)(?:\n\n|$)/);
  let cleanedText = text;
  const sources: ParsedCitation[] = [];

  if (sourcesMatch) {
    cleanedText = text.replace(sourcesMatch[0], '').trim();
    const lines = sourcesMatch[1].split('\n').filter(l => l.trim().startsWith('-'));
    for (const line of lines) {
      const raw = line.replace(/^-\s*/, '').split(' - ')[0].trim();
      if (raw.length > 3) {
        sources.push({ raw, url: makeCitationUrl(raw) });
      }
    }
  }

  return { cleanedText, sources };
}
